var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1000.04645px",
    height: "323.653104px",
    viewBox: "0 0 1000.04645 323.653104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SurveyReel-UK",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Visa_Inc._logo",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "polygon9",
    fill: "#00579F",
    points: "433.35228 318.983923 352.341545 318.983923 403.011463 5.67921269 484.017768 5.67921269"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.023394,13.3386189 C711.044517,6.9993417 685.700698,0 654.363139,0 C574.362436,0 518.026595,42.6605447 517.681058,103.652277 C517.016563,148.651842 558.015872,173.645694 588.680077,188.649979 C620.022065,203.982081 630.676127,213.989368 630.676127,227.655804 C630.357169,248.644969 605.350028,258.320008 582.026272,258.320008 C549.683111,258.320008 532.353096,253.33187 506.016965,241.654487 L495.349614,236.648629 L484.013338,306.978723 C503.01345,315.634871 538.019018,323.316427 574.362436,323.653104 C659.364568,323.653104 714.703667,281.652624 715.359301,216.656205 C715.682689,180.990572 694.033459,153.66213 647.359368,131.330686 C619.025324,116.995325 601.673158,107.329146 601.673158,92.6615382 C602.005406,79.3273492 616.349626,65.669773 648.33396,65.669773 C674.67009,65.0008486 694.020169,71.3312658 708.678917,77.6661131 L716.006076,80.9930154 L727.023394,13.3386189 L727.023394,13.3386189 L727.023394,13.3386189 Z",
    id: "path11",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.693647,207.991198 C841.365172,189.992257 867.036808,120.331088 867.036808,120.331088 C866.700131,121.000012 873.695042,101.9999 877.695299,90.3358075 L883.356792,117.332003 C883.356792,117.332003 898.697754,192.326848 902.029086,207.991198 C889.368252,207.991198 850.694674,207.991198 834.693647,207.991198 L834.693647,207.991198 Z M934.691204,5.67921269 L872.029376,5.67921269 C852.705877,5.67921269 838.02498,11.3407055 829.687789,31.6742362 L709.356701,318.979493 L794.358833,318.979493 C794.358833,318.979493 808.353087,280.310345 811.361032,271.982014 C820.686104,271.982014 903.375795,271.982014 915.372135,271.982014 C917.697866,282.981613 925.038315,318.979493 925.038315,318.979493 L1000.04645,318.979493 L934.691204,5.67921269 L934.691204,5.67921269 L934.691204,5.67921269 Z",
    id: "path13",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.678289,5.67921269 L205.34208,219.323043 L196.672642,175.993574 C182.005034,125.99701 136.004297,71.676803 84.6698847,44.6673179 L157.338999,318.651676 L243.005626,318.651676 L370.340485,5.67921269 L284.678289,5.67921269 L284.678289,5.67921269 L284.678289,5.67921269 Z",
    id: "path15",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.671793,5.67921269 L1.33341889,5.67921269 L0,12.00963 C101.672083,38.0090834 169.007522,100.679771 196.672642,176.006864 L168.338598,32.0153433 C163.673847,12.0052 149.338486,6.3392772 131.671793,5.67921269 L131.671793,5.67921269 Z",
    id: "path17",
    fill: "#FAA61A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVisa);
export default __webpack_public_path__ + "static/media/logo-visa.b6b8ac8c0a283b8b7e16562d7d7331c3.svg";
export { ForwardRef as ReactComponent };